import type { Site } from '../Site';

export const TheField: Site = {
  id: 'thefield',
  analyticsName: 'thefield',
  selector: '#content a',
  logo: '',
  label: 'The Field',
  platform: '',
};
